import { Box } from "@mui/material";
import NavBar from "./NavBar";

const Layout = ({ children }: any) => {
  // Get the current pathname
  const { pathname } = window.location;

  const showNavBar = !pathname.includes("checkout");

  return (
    <Box >
      {showNavBar ? <NavBar /> : <></>}
      {children}
    </Box>
  );
};

export default Layout;

